const F = {
  color: {
    primary: {
      100: "#F1F8FF",
      200: "#79BEEF",
      300: "#42ADFF",
      400: "#108DE0",
      500: "#0071C7",
      600: "#004986",
      700: "#003A6B",
      800: "#0B2F4D"
    },
    white: "#FFFFFF",
    grey: {
      50: "#F6F7F8",
      100: "#EEEFEF",
      200: "#E5E6E7",
      300: "#D3D5D6",
      400: "#AAAEB0",
      500: "#868A8D",
      600: "#63676A",
      700: "#46484A",
      800: "#36383A",
      900: "#212121"
    },
    black: "#000000",
    functional: {
      101: "#F3FFF3",
      102: "#94DE82",
      103: "#009419",
      104: "#005C05",
      201: "#FFFAE3",
      202: "#FCD778",
      203: "#FDC20C",
      204: "#B54D08",
      301: "#FFEFEF",
      302: "#FC7878",
      303: "#D90202",
      304: "#8E0000",
      401: "#FFE6FF",
      402: "#FF88AB",
      403: "#FF004D",
      404: "#5F002D",
      501: "#F1F8FF",
      502: "#42ADFF",
      503: "#0071C7",
      504: "#004986"
    },
    transparent: {
      black8p: "#00000014",
      black10p: "#00000019",
      black20p: "#00000033",
      black26p: "#00000042",
      black50p: "#0000007f",
      primary8: "#0071c714",
      primary15: "#0071c726",
      primary20: "#0071c733"
    }
  },
  sizing: {
    radius: {
      corner: {
        25: "2px",
        50: "4px",
        100: "8px",
        200: "16px",
        300: "24px",
        400: "32px",
        500: "40px",
        600: "48px",
        900: "72px"
      }
    },
    size: {
      unit: {
        0: "0px",
        25: "2px",
        50: "4px",
        100: "8px",
        200: "16px",
        300: "24px",
        400: "32px",
        500: "40px",
        600: "48px",
        700: "56px",
        800: "64px",
        900: "72px",
        1e3: "80px",
        1100: "88px",
        1200: "96px"
      }
    },
    stroke: {
      weight: {
        100: "1px",
        200: "2px",
        400: "4px",
        800: "8px"
      }
    }
  }
};
export {
  F as b
};
